import { LoadingUserState } from "@tsin-core/models/user.model";

export class SetUserLoading {
    static readonly type = '[User] Set Loading';
    constructor(public loading: LoadingUserState) { }
}

export class SetUserError {
    static readonly type = '[User] Set Error';
    constructor(public error: string | null) { }
}